import {
  GET_PROJECTS_CATALOG,
  GET_PROJECTS_CATALOG_SUCCESS,
  GET_PROJECTS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const getProjectsCatalogRed = (state: any, actions: any) => {
  switch (actions.type) {
    case GET_PROJECTS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_PROJECTS_CATALOG_SUCCESS:
      return {
        data: actions.payload,
        loading: false,
        error: null,
      };
    case GET_PROJECTS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: null,
      };
    default:
      return state;
  }
};
